import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { saveMetaData } from "../store/dataFlow/actions";
import { plansDetails } from "../utils/PlanDetails";
import {
  Container,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableRow,
  Chip,
} from "@mui/material";
import UserService from "../KeyCloackServices/UserService";
import { Button } from "@material-tailwind/react";

const entheoProPlan = plansDetails.filter((plan) => plan.name === "EntheoPro");
// Reusable TableRow Component
const TableRowItem = ({ label, value }) => (
  <TableRow>
    <TableCell>
      <span>
        <strong>{label}</strong>
      </span>
      <br />
      <span className="text-mute text-gray-600">{value || "N/A"}</span>
    </TableCell>
  </TableRow>
);

const DocMetaDeta = () => {
  const dispatch = useDispatch();
  const { selectedMetaData } = useSelector((state) => state.dataFlow);
  const [openUpgrade, setOpenUpgrade] = useState(false);
  const [selectedRef, setSelectedRef] = useState({
    title: null,
    refDetails: null,
  });

  const handleCloseRef = () => {
    dispatch(saveMetaData(null));
  };

  return (
    <React.Fragment>
      <div className="overflow-y-auto max-h-[calc(100vh)] py-7  md:max-h-[calc(100vh)] lg:max-h-[calc(100vh)] xl:max-h-[calc(100vh)]">
        <div className="modal-header flex justify-between items-center px-3 py-4">
          <div className="flex justify-start items-center">
            <span className={`modal-title font-bold `}>MetaData</span>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="mr-3 h-5 w-5 cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              handleCloseRef();
            }}
          >
            <path
              fillRule="evenodd"
              d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </div>

        {selectedMetaData ? (
          <TableContainer>
            {selectedMetaData?.metadata ? (
              <Table>
                <TableBody>
                  <TableRowItem
                    label="Document Title"
                    value={selectedMetaData?.metadata?.document_title}
                  />
                  <TableRowItem
                    label="Legal Citation"
                    value={selectedMetaData?.metadata?.legal_citation}
                  />
                  <TableRowItem
                    label="Summary"
                    value={selectedMetaData?.metadata?.summary}
                  />
                  <TableRowItem
                    label="Filing Status"
                    value={
                      selectedMetaData?.metadata?.filing_status && (
                        <span className="border-2 border-[#7a6fbe] rounded-full px-2 py-1 !text-[10px]">
                          {selectedMetaData?.metadata?.filing_status}
                        </span>
                      )
                    }
                  />
                  <TableRowItem
                    label="Court/Agency Name"
                    value={selectedMetaData?.metadata?.court_or_agency_name}
                  />
                  <TableRowItem
                    label="Jurisdiction Court"
                    value={selectedMetaData?.metadata?.jurisdiction?.court}
                  />
                  <TableRowItem
                    label="Jurisdiction Level"
                    value={selectedMetaData?.metadata?.jurisdiction?.level}
                  />
                  <TableRowItem
                    label="Jurisdiction State"
                    value={selectedMetaData?.metadata?.jurisdiction?.state}
                  />
                  <TableRowItem
                    label="Docket Number"
                    value={selectedMetaData?.metadata?.docket_number}
                  />
                  <TableRowItem
                    label="Procedural Posture"
                    value={selectedMetaData?.metadata?.procedural_posture}
                  />
                  <TableRowItem
                    label="Document Type"
                    value={selectedMetaData?.metadata?.document_type}
                  />
                  <TableRowItem
                    label="Filing Date"
                    value={selectedMetaData?.metadata?.filing_date}
                  />
                  <TableRowItem
                    label="Decision Date"
                    value={selectedMetaData?.metadata?.decision_date}
                  />
                  <TableRowItem
                    label="Parties Involved"
                    value={
                      <div className="flex flex-col gap-y-1 mx-2">
                        <div className="text-sm">
                          <span>•</span>
                          <strong>Defendant:</strong>{" "}
                          {
                            selectedMetaData?.metadata?.parties_involved
                              ?.defendant
                          }
                        </div>
                        <div className="text-sm">
                          <span>•</span>
                          <strong>Plaintiff:</strong>{" "}
                          {
                            selectedMetaData?.metadata?.parties_involved
                              ?.plaintiff
                          }
                        </div>
                      </div>
                    }
                  />
                  <TableRowItem
                    label="Outcome Decision"
                    value={selectedMetaData?.metadata?.outcome_decision}
                  />
                  <TableRowItem
                    label="Related Cases"
                    value={selectedMetaData?.metadata?.related_cases?.map(
                      (caseItem, index) => (
                        <div key={index} className="mb-2">
                          <div>
                            <strong>
                              {index + 1}. {caseItem.case_name}
                            </strong>
                          </div>
                          <div className="ps-3">
                            <strong>Citation:</strong> {caseItem.citation}
                          </div>
                        </div>
                      )
                    )}
                  />
                </TableBody>
              </Table>
            ) : (
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell className="text-xl  font-bold !text-center">
                      <div
                        style={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          WebkitLineClamp: 2,
                        }}
                      >
                        {selectedMetaData?.title ??
                          selectedMetaData?.name ??
                          "N/A"}
                      </div>
                      {selectedMetaData?.author && (
                        <>
                          <br />
                          <span className="text-mute text-gray-600 text-sm">
                            {"by " +
                              (selectedMetaData?.author.length > 20
                                ? selectedMetaData?.author.substring(0, 20) +
                                  "..."
                                : selectedMetaData?.author)}
                          </span>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <span>
                        <strong>Abstract</strong>
                      </span>
                      <br />
                      <span className="text-mute text-gray-600">
                        {selectedMetaData?.abstract
                          ? selectedMetaData?.abstract
                          : "N/A"}
                      </span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <span>
                        <strong>Publication date</strong>
                      </span>
                      <br />
                      <span className="text-mute text-gray-600">
                        {selectedMetaData?.publication_date
                          ? selectedMetaData?.publication_date
                          : "N/A"}
                      </span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <span>
                        <strong>DOI. (Digital Object Identifier)</strong>
                      </span>
                      <br />
                      <span className="text-mute text-gray-600">
                        {selectedMetaData?.doi ? selectedMetaData?.doi : "N/A"}
                      </span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <span>
                        <strong>Journal name</strong>
                      </span>
                      <br />
                      <span className="text-mute text-gray-600">
                        {selectedMetaData?.journal_name
                          ? selectedMetaData?.journal_name
                          : "N/A"}
                      </span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <span>
                        <strong>Notes</strong>
                      </span>
                      <br />
                      <span className="text-mute text-gray-600">
                        {selectedMetaData?.notes
                          ? selectedMetaData?.notes
                          : "N/A"}
                      </span>
                    </TableCell>
                  </TableRow>
                </TableBody>
                {(UserService.getRole()?.roles?.includes("admin") ||
                  UserService.getRole()?.roles?.includes("pro")) && (
                  <div className="flex justify-center items-center my-2">
                    <Button
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = selectedMetaData?.originalUrl;
                        link.download = selectedMetaData?.title
                          ? selectedMetaData?.title
                          : "N/A";
                        link.target = "_blank";
                        link.rel = "noopener noreferrer";
                        link.click();
                      }}
                    >
                      Download Doc
                    </Button>
                  </div>
                )}
              </Table>
            )}
          </TableContainer>
        ) : (
          <span>Loading ...</span>
        )}
      </div>
    </React.Fragment>
  );
};

export default DocMetaDeta;
